import { AuthConsumer } from "./authProvider";
import { LoadingIndicator } from "../components/common/VFX-UI";

const Signin = (props: any) => {
  const { children } = props;
  return (
    <AuthConsumer>
      {({ isAuthenticated, signinRedirect }) => {
        if (isAuthenticated()) {
          return children;
        } else {
          signinRedirect();
          return <LoadingIndicator />;
        }
      }}
    </AuthConsumer>
  );
};

export default Signin;
